import readTimeEstimate from 'read-time-estimate/dist/read-time-estimate.js';

export function useReadingTimeInMinutesFromModulesArray(modules) {
    return useReadingTimeInMinutes(useConvertModulesArrayToHtmlString(modules));
}

export function useReadingTimeInMinutes(html = '') {
    const stats = readTimeEstimate(html, 265, 12, 500, ['img', 'Image', 'bard-set']);

    return Math.ceil(stats.duration);
}

export function useConvertModulesArrayToHtmlString(modules) {
    return modules.map(module => {
        const htmlTags = [];

        if (module.image) {
            htmlTags.push('<img>');
        }

        if (module.caption) {
            htmlTags.push(module.caption);
        }

        if (module.source) {
            htmlTags.push(module.source);
        }

        if (module.text) {
            htmlTags.push(module.text);
        }

        return htmlTags.join('');
    }).join('');
}
